import type { RubricaLoteFilters } from '@/services/ServiceRubricaLote';
import { AnaliseGrauExposicaoRisco } from '@/types/analise/AnaliseGrauExposicaoRisco';
import { RubricaSituacao } from '@/constants/rubricas/situacao/RubricaSituacao';
import { AnaliseStatus } from '@/constants/analise/AnaliseStatus';

export interface AppliedFilters {
  risks: AnaliseGrauExposicaoRisco[];
  occurrences: number[];
  natures: number[];
  types: string[];
  situations: RubricaSituacao[];
  employerCnpjs: string[];
  tableIds: string[];
  exception: boolean | null;
  payrollUsage: boolean | null;
  statuses: AnaliseStatus[];
}

export const EMPTY_FILTERS: AppliedFilters = {
  risks: [],
  occurrences: [],
  natures: [],
  types: [],
  situations: [],
  employerCnpjs: [],
  tableIds: [],
  exception: null,
  payrollUsage: null,
  statuses: [],
};

export function requestFilters(filters: AppliedFilters, search: string): RubricaLoteFilters {
  return {
    ...(search ? { search } : {}),
    ...(filters.risks.length ? { grauRisco: filters.risks } : {}),
    ...(filters.occurrences.length ? { ocorrencia: filters.occurrences } : {}),
    ...(filters.natures.length ? { natureza: filters.natures } : {}),
    ...(filters.types.length ? { tipo: filters.types } : {}),
    ...(filters.situations.length ? { situacao: filters.situations } : {}),
    ...(filters.employerCnpjs.length ? { cnpjEmpregador: filters.employerCnpjs } : {}),
    ...(filters.tableIds.length ? { idTabela: filters.tableIds } : {}),
    ...(filters.exception == null ? {} : { excecao: filters.exception }),
    ...(filters.payrollUsage == null ? {} : { usoEmFolha: filters.payrollUsage }),
    ...(filters.statuses.length ? { statusAnalise: filters.statuses } : {}),
  };
}
